// This import loads the firebase namespace along with all its type information.
import firebase from 'firebase/compat/app'

// These imports load individual services into the firebase namespace.
// import "firebase/auth"
import "firebase/compat/auth"
import 'firebase/compat/firestore'
import 'firebase/compat/functions'



// Initialize Firebase
var config = {
    apiKey: "AIzaSyCwQIC_xu001E7Urdi0spCdMNJnCPap3dg",
    authDomain: "account-new-23.firebaseapp.com",
    projectId: "account-new-23",
    storageBucket: "account-new-23.appspot.com",
    messagingSenderId: "338345091333",
    appId: "1:338345091333:web:5e85468782bf84f293d76c"
};
firebase.initializeApp(config)

// const db = firebase.firestore()
// const auth = firebase.auth()

//db.settings({timestampsInSnapshots: true})
// export default (db,auth)
// export default (db)
export const fieldValue = firebase.firestore.FieldValue // Delete field in firebase
export const db = firebase.firestore()
export const auth = firebase.auth()
export const functions = firebase.functions()